import getWikiButton from './getWikiButton.js';

const rebuildLayout = () => {
    const wikiButton = getWikiButton();
    $$('tempLayout').addView(wikiButton, -1);
};

export default rebuildLayout;
